import React from 'react'

export default function Usp() {
  return (
    <>
      <section className="usp">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h2 className="heading">Embark on Adventures with Us</h2>
            </div>
            <div className="col-md-3">
                <div className="subUsp">
                    <img src="assets/img/usp1.png" alt="" />
                    <h3>Exceptional Customer Service</h3>
                    <p>Our dedicated team is committed to providing exceptional customer service at every stage of your journey. From planning your trip to providing assistance during your travels, we are here to ensure your satisfaction.</p>
                </div>
            </div>
            <div className="col-md-3">
                <div className="subUsp">
                    <img src="assets/img/usp2.png" alt="" />
                    <h3>Customized Itineraries</h3>
                    <p>Enjoy personalized travel experiences tailored to your preferences, budget, and interests. We believe in crafting unique itineraries that cater to the individual needs of each traveler.</p>
                </div>
            </div>
            <div className="col-md-3">
                <div className="subUsp">
                    <img src="assets/img/usp3.png" alt="" />
                    <h3>Global Network</h3>
                    <p>Benefit from our extensive network of partners and suppliers around the world. Whether you're planning a weekend getaway or a round-the-world adventure, we can help you make it happen.</p>
                </div>
            </div>
            <div className="col-md-3">
                <div className="subUsp">
                    <img src="assets/img/usp4.png" alt="" />
                    <h3>Exclusive Deals &amp; Discounts</h3>
                    <p>Take advantage of exclusive deals and discounts offered by our travel company. We strive to provide the best value for your money without compromising on quality.</p>
                </div>
            </div>
        </div>
    </div>
</section>
    </>
  )
}
